import NpsByDayOfWeekWidget from './NpsByDayOfWeekWidget';
export default NpsByDayOfWeekWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsByDayOfWeekWidget/index.js